import { createContext, useContext } from 'react'

export interface FilterPanelContextValue {
    values: Record<string, unknown>
    setValue: (name: string, value: unknown) => void
    clearValue: (name: string) => void
}

const FilterPanelContext = createContext<FilterPanelContextValue | null>(null)

export const useFilterPanel = () => {
    const ctx = useContext(FilterPanelContext)
    if (!ctx) throw new Error('useFilterPanel debe usarse dentro de <FilterPanel>')
    return ctx
}

export default FilterPanelContext
